var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackSpaceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8591 14.3906H29.9714C30.2515 14.3906 30.5202 14.4908 30.7183 14.669C30.9163 14.8473 31.0276 15.0891 31.0276 15.3412V29.5994C31.0276 29.8515 30.9163 30.0933 30.7183 30.2715C30.5202 30.4498 30.2515 30.5499 29.9714 30.5499H10.9605C10.6803 30.5499 10.4117 30.4498 10.2136 30.2715C10.0156 30.0933 9.9043 29.8515 9.9043 29.5994V15.3412C9.9043 15.0891 10.0156 14.8473 10.2136 14.669C10.4117 14.4908 10.6803 14.3906 10.9605 14.3906H13.0728",
    stroke: "#5770CB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8591 14.3906H29.9714C30.2515 14.3906 30.5202 14.4908 30.7183 14.669C30.9163 14.8473 31.0276 15.0891 31.0276 15.3412V29.5994C31.0276 29.8515 30.9163 30.0933 30.7183 30.2715C30.5202 30.4498 30.2515 30.5499 29.9714 30.5499H10.9605C10.6803 30.5499 10.4117 30.4498 10.2136 30.2715C10.0156 30.0933 9.9043 29.8515 9.9043 29.5994V15.3412C9.9043 15.0891 10.0156 14.8473 10.2136 14.669C10.4117 14.4908 10.6803 14.3906 10.9605 14.3906H13.0728",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4668 19.1436V5.83594",
    stroke: "#5770CB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4668 19.1436V5.83594",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 9.63813L20.4668 5.83594L24.6915 9.63813",
    stroke: "#5770CB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2422 9.63813L20.4668 5.83594L24.6915 9.63813",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackSpaceIcon);
export default __webpack_public_path__ + "static/media/feedbackSpaceIcon.bf42ccc8.svg";
export { ForwardRef as ReactComponent };